import { PaletteDTO } from "../common/palette.models";

export class ProductPaletteLimitDTO {
  productId: number;
  palette: PaletteDTO;
  productPaletteLimitId: number;
  stockLimit: number;
  minimumQuantityForPreOrder: number;
  minimumQuantityForReOrder: number;
  constructor(init?: ProductPaletteLimitDTO) {
    Object.assign(this, init);
  }
}

export class StockLimitProductPaletteVM extends ProductPaletteLimitDTO {
  isDeleted: boolean;
  constructor(init?: StockLimitProductPaletteVM) {
    super();
    Object.assign(this, init);
  }
}


export class limitDTI {
  stockLimit: number;
  minimumQuantityForPreOrder: number;
  minimumQuantityForReOrder: number;
  constructor(init?: limitDTI) {
    Object.assign(this, init);
  }

}
